import { useEffect, useRef, useState } from 'react';
import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import type { RetratoDoMembro } from '../realtime/cityHub';

type Modo = 'sem_loot' | 'com_loot';

/**
 * O menu de desafiar (duelo v2, Renato, 29/10/2026): o retrato de quem você desafia, o modo em dois cartões
 * (Amistoso ou Valendo loot), a chave da aposta de itens e as regras numa linha. Sem aposta, o aceite leva os dois
 * direto para a arena; com aposta, abre a janela da aposta antes.
 */
export function DueloConfigGump({
  nome, retratoDe, onEnviar, onClose
}: {
  nome: string;
  retratoDe(canvas: HTMLCanvasElement, nome: string, look: RetratoDoMembro | null): () => void;
  onEnviar(modo: Modo, aposta: boolean): void;
  onClose(): void;
}) {
  const [modo, setModo] = useState<Modo>('sem_loot');
  const [aposta, setAposta] = useState(false);
  const cv = useRef<HTMLCanvasElement>(null);
  const pintar = useRef(retratoDe);
  pintar.current = retratoDe;
  useFechar(onClose, { modal: true });
  useEffect(() => {
    const c = cv.current;
    if (!c) return;
    return pintar.current(c, nome, null);
  }, [nome]);
  const loot = modo === 'com_loot';

  return (
    <div className="modal" role="presentation" onClick={onClose}>
      <div className="dz-desafio" role="dialog" aria-modal="true" aria-labelledby="dz-desafio-nome" onClick={e => e.stopPropagation()}>
        <div className="dz-desafio__cab">
          <canvas ref={cv} className="dz-retrato" width={52} height={52} aria-hidden="true" />
          <div className="dz-desafio__quem">
            <div className="dz-kicker">{t('duelo.desafio.kicker')}</div>
            <div className="dz-desafio__nome" id="dz-desafio-nome">{nome}</div>
          </div>
          <button type="button" className="dz-desafio__x" aria-label={t('comum.fechar')} onClick={onClose}>×</button>
        </div>
        <div className="dz-desafio__corpo">
          <div className="dz-secao">
            <div className="dz-secao__t" id="dz-modo-t">{t('duelo.desafio.como')}</div>
            <div className="dz-modos" role="radiogroup" aria-labelledby="dz-modo-t">
              <button type="button" className="dz-modo" role="radio" aria-checked={!loot} onClick={() => setModo('sem_loot')}>
                <svg className="dz-modo__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 3 4.5 6v5.5c0 4.5 3.2 8.2 7.5 9.5 4.3-1.3 7.5-5 7.5-9.5V6Z" /><path d="m9 12 2 2 4-4" />
                </svg>
                <span className="dz-modo__t">{t('duelo.semLoot')}</span>
                <span className="dz-modo__d">{t('duelo.desafio.amistosoLinha')}</span>
              </button>
              <button type="button" className="dz-modo dz-modo--loot" role="radio" aria-checked={loot} onClick={() => setModo('com_loot')}>
                <svg className="dz-modo__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 3c-4.4 0-8 3.2-8 7.3 0 2.4 1.2 4.5 3 5.8V19h2v2h6v-2h2v-2.9c1.8-1.3 3-3.4 3-5.8C20 6.2 16.4 3 12 3Z" /><circle cx="9" cy="11" r="1.6" /><circle cx="15" cy="11" r="1.6" />
                </svg>
                <span className="dz-modo__t">{t('duelo.comLoot')}</span>
                <span className="dz-modo__d">{t('duelo.desafio.lootLinha')}</span>
              </button>
            </div>
            {loot && <p className="dz-alerta-loot">⚠ {t('duelo.desafio.lootAviso')}</p>}
          </div>
          <div className="dz-secao">
            <div className="dz-secao__t">{t('duelo.desafio.aposta')}</div>
            <button type="button" className="dz-chave" role="switch" aria-checked={aposta} onClick={() => setAposta(v => !v)}>
              <span className="dz-chave__bola" aria-hidden="true" />
              <span>
                <b>{t('duelo.desafio.apostar')}</b>
                <span>{aposta ? t('duelo.desafio.comApostaLinha') : t('duelo.desafio.semApostaLinha')}</span>
              </span>
            </button>
          </div>
          <p className="dz-regras">{t('duelo.desafio.regras')}</p>
        </div>
        <div className="dz-desafio__pe">
          <button type="button" className="btn btn--ghost" onClick={onClose}>{t('comum.cancelar')}</button>
          <button type="button" className="btn btn--primary" onClick={() => onEnviar(modo, aposta)}>⚔ {t('duelo.configEnviar')}</button>
        </div>
      </div>
    </div>
  );
}
